module.exports = __webpack_public_path__ + "img/settings-linkhealthcareaccount-icon.c216dcf6.svg";